import snakecaseKeys from 'snakecase-keys';
import { ApiService } from '../../../ApiService';
import { VcsProvider } from '../../../../enums/IntegrationProvider/VcsProvider';
import {
  InterviewTemplate,
  InterviewTemplateList,
} from '../../../../entities/v1/applicant_tracking/InterviewTemplate';

export interface UpsertInterviewTemplateRequest {
  id?: number;
  name: string;
  participantUserIds: number[];
  organizerUserId: number;
  meetingDuration: number;
  meetingProvider?: VcsProvider;
  scheduleFromHours: number;
  dateRange: number;
  timezone: string;
}

interface DetailParams {
  expand?: string[];
  includeFields?: string[];
}

export interface ListInterviewTemplateRequest extends DetailParams {
  name?: string;
}

interface ListInterviewTemplatesByUserParams {
  organizerUserId: number;
}

export class InterviewTemplateService {
  public static upsert(
    interview_template: UpsertInterviewTemplateRequest,
  ): Promise<void> {
    if (interview_template.id) {
      return this.update(interview_template);
    }

    return this.create(interview_template);
  }

  public static create(
    interview_template: UpsertInterviewTemplateRequest,
  ): Promise<void> {
    return ApiService.post<void>(
      `/api/v1/applicant_tracking/interview_templates`,
      snakecaseKeys({ interview_template }),
    );
  }

  public static update(
    interview_template: UpsertInterviewTemplateRequest,
  ): Promise<void> {
    return ApiService.put<void>(
      `/api/v1/applicant_tracking/interview_templates/${interview_template.id}`,
      snakecaseKeys({ interview_template }),
    );
  }

  public static list(
    request: ListInterviewTemplateRequest = {},
  ): Promise<InterviewTemplateList> {
    return ApiService.get<InterviewTemplateList>(
      `/api/v1/applicant_tracking/interview_templates`,
      snakecaseKeys({ name: request.name, expand: request.expand }),
    );
  }

  public static get(
    interviewTemplateId: number,
    params?: DetailParams,
  ): Promise<InterviewTemplate> {
    return ApiService.get<InterviewTemplate>(
      `/api/v1/applicant_tracking/interview_templates/${interviewTemplateId}`,
      snakecaseKeys(params),
    );
  }

  public static listInterviewTemplatesByOrganizerUser(
    params: ListInterviewTemplatesByUserParams,
  ): Promise<InterviewTemplateList> {
    return ApiService.get<InterviewTemplateList>(
      `/api/v1/applicant_tracking/interview_templates`,
      snakecaseKeys(params),
    );
  }
}
